// extracted by mini-css-extract-plugin
export default {"versions":"Footer_versions__BfhJD","indicatorActive":"Footer_indicatorActive__8elVy","indicatorInactive":"Footer_indicatorInactive__hEx33"};